import type { StoredPage } from "../../../redux/shared/paged-list.ts"
import type { SaveResult } from "../../../redux/shared/types.ts"
import type {
  ProjectTypeTemplate,
  ProjectTypeTemplatePhase
} from "../types/project-type.types.ts"

enum SaveResultType {
  PROJECT_TYPE_UPDATE = "project_type_update",
  PROJECT_TYPE_CREATE = "project_type_create",
  //
  PHASE_UPDATE = "phase_update",
  PHASE_CREATE = "phase_create"
}

type TemplatesSaveResult = SaveResult<SaveResultType>

interface ProjectTypesFilters {
  q?: string | null
  [key: string]: any
}

interface TemplatesState {
  fetching: boolean
  requestId: string | null
  saveFetching: boolean
  saveResult: TemplatesSaveResult

  projectTypeDetails?: ProjectTypeTemplate | null
  selectedPhase: ProjectTypeTemplatePhase | null

  //
  projectTypes: {
    filters: ProjectTypesFilters
    result: StoredPage<ProjectTypeTemplate>
    autocompleteList: any[]
  }
}

export type { TemplatesState, TemplatesSaveResult, ProjectTypesFilters }

export { SaveResultType }
